const ICON_FALLBACKS: Record<string, string> = {
  grid_view: "dashboard",
  handshake: "assignment_turned_in",
  home: "apps",
  insights: "trending_up",
  inventory_2: "inventory",
  logout: "exit_to_app",
};

export function resolveMaterialIconName(icon: string | null | undefined): string {
  const normalized = String(icon || "").trim();
  if (!normalized) {
    return "arrow_forward";
  }

  return ICON_FALLBACKS[normalized] || normalized;
}
